/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./node/window (ignored)
// module id = 2
// module chunks = 0